export default "__VITE_ASSET__439uLAIk__"